import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const SignalLow: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 20h.01' }],
    ['path', { d: 'M7 20v-4' }],
  ],
];

export default SignalLow;
